// Event.js

import React, { Component } from 'react';
//import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import axios from 'axios';
import Form from "react-jsonschema-form";
import JSONSchemaForm from "react-jsonschema-form";
import { connect } from 'react-redux';
import { updateAlert } from '../actions/alert-actions';

class Rooms extends Component {
  state = {
    event: [],
    Form: JSONSchemaForm.default,
      jsonSchema: {
      "title": "Assign Dressing Rooms",
      "description": "Assign Rooms fo this event",
      "type": "object",
      "required": [
        "home_room",
        "away_room"
      ],
      "properties": {
        "home_room": {
          "type": "integer",
          "title": "Home Room",
          "enum": [0, 1, 2, 3, 4],
          "enumNames"  : ['None', 'Room 1', 'Room 2', 'Room 3', 'Room 4']
        },
        "away_room": {
          "type": "integer",
          "title": "Away Room",
          "enum": [0, 1, 2, 3, 4],
          "enumNames"  : ['None', 'Room 1', 'Room 2', 'Room 3', 'Room 4']
        }
      }
    },
    uiSchema: {
      "home_room": {
        "ui:autofocus": true,
        "ui:widget": "select"
      },
      "away_room": {
        "ui:widget": "select"
      },
    }
  }

  onSubmit(formData) {
    console.log("rooms", formData.formData);
    var response = fetch('https://beisekerice.com/api/v0/events/' + this.props.match.params.id + '/rooms', {
    //  var response = fetch('http://localhost:3001/api/v0/events/' + this.props.match.params.id + '/rooms', {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + this.props.user.token
      },
      body: JSON.stringify(formData.formData)
    }).then(response => {
      if (!response.ok) {
          console.log(response.statusText);
          return Promise.reject(response.statusText);
      }
      console.log(response.statusText);
      this.props.history.push(`/admin/rooms`);
  })
  .catch(error => {
    console.log(error);
    this.props.onUpdateAlert("Unable to set rooms");
  });
  }

  componentDidMount() {
    axios.get("https://beisekerice.com/api/v0/events/"+this.props.match.params.id)
      .then(res => {
        const event = res.data;
        this.setState({ event });
      })
  }

  render() {

    return (
        <div class="eventView">
                  <div className="container">
            <div className="col-sm-6 offset-sm-3 mt-2">
                {this.props.alert &&
                    <div className={'alert alert-warning'}>{this.props.alert}</div>
                }
            </div>
        </div>
          <h2>Event</h2>
          <p>Title: { this.state.event.title }</p>
          <p>Start:  <Moment format="YYYY/MM/DD hh:mm a" date={this.state.event.start} /></p>
          <p>End: <Moment format="YYYY/MM/DD hh:mm a" date={this.state.event.end} /></p>
          <p>Duration: <Moment diff={this.state.event.start} unit="hours" decimal>{this.state.event.end}</Moment> hour(s)</p>
          <p>Type: { this.state.event.type }</p>

          <div>
          <Form schema={this.state.jsonSchema}
            className="form form-wide"
            uiSchema={this.state.uiSchema}
            onSubmit={this.onSubmit.bind(this)} />

          <button className='btn btn-info' onClick={this.props.history.goBack}>Back</button>
          </div>
        </div>
    );
  }
}


const mapStateToProps = state => ({
  cart: state.cart,
  user: state.user,
  alert: state.alert
});

const mapActionsToProps = {
  onUpdateAlert: updateAlert
};

export default connect(mapStateToProps, 
  mapActionsToProps
  )(Rooms);


// WEBPACK FOOTER //
// ./src/components/Rooms.js